import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../../common/http/http-provider.service';
import { ConstructionElement, CopyElementDTO, Frame, Glass } from '../../../shared/model/construction-element';

@Injectable()
export class SharedDataRepository extends HttpProvider {
  constructor(http: HttpClient) {
    super(http);
  }
  GetElementsByModule(module: number, entity: number): any {

    return new Promise<any>((resolve) => {
      this.get<any>('constructionElement/GetElementsByModule?module=' + module + '&entity=' + entity)
        .subscribe((data: any) => {
          var result = data.result;
          resolve(result);
        },
          (error) => {
            resolve({});
          });
    });
  }
  GetElementById(elementId: number) {
    return this.get('constructionElement/GetElementById?id=' + elementId);
  }
  SaveConstructionElement(data: ConstructionElement) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/Save/`, data)
        .subscribe((data: any) => {
          var result = data.result;
          resolve(result);
        },
          (error) => {
            resolve({});
          });
    });
  }
  getGlassId(data: any) {
    if (data.g_Id > 0)
      return this.put('constructionElement/Glass', data);
    else
      return this.post('constructionElement/Glass', data);
  }
  deleteElement(id: number) {
    return this.post('constructionElement/Delete', [id]);
  }
  saveGlass(data: Glass, id: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/ElementGlass/` + id, data)
        .subscribe((data: any) => {
          var result = data.Result;
          resolve(true);
        },
          (error) => {
            resolve(false);
          });
    });
  }
  saveFrame(data: Frame, id: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/ElementFrame/` + id, data)
        .subscribe((data: any) => {
          var result = data.result;
          resolve(true);
        },
          (error) => {
            resolve(false);
          });
    });
  }

  copyElement(elementId: number, param: CopyElementDTO) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/Copy/` + elementId, param)
        .subscribe((data: any) => {
          var result = data.result;
          resolve(true);
        },
          (error) => {
            resolve(false);
          });
    });
  }

  copyGlass(elementId: number, glassId: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/CopyGlass/` + elementId + '/' + glassId, {})
        .subscribe((data: any) => {
          var result = data.result; resolve(result);
        },
          (error) => {
            resolve(false);
          });
    });
  }

  deleteGlass(elementId: number, glassId: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/DeleteGlass/` + elementId + '/' + glassId, {})
        .subscribe((data: any) => {
          var result = data.result; resolve(result);
        },
          (error) => {
            resolve(false);
          });
    });
  }
  deleteFrame(elementId: number, frameId: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/DeleteFrame/` + elementId + '/' + frameId, {})
        .subscribe((data: any) => {
          var result = data.result; resolve(result);
        },
          (error) => {
            resolve(false);
          });
    });
  }
  saveOrUpdate(data: any, id: number) {
    return new Promise<any>((resolve) => {
      this.post<any>(`constructionElement/GlassList/`+ id, data)
        .subscribe((data: any) => {
        var result = data.result;
        resolve(result);
      },
    (error)=>{
      resolve(false);
    })
    })
  }
}
